// Authority dropdown options for inspections.
// `value` is the literal string stored in the DB; `label` is the display label.
// "other" is a sentinel that triggers a free-text fallback in the form.
export const AUTHORITY_OPTIONS = [
  { value: "NAV", label: "NAV (Adó- és Vámhivatal)" },
  { value: "NÉBIH", label: "NÉBIH (Élelmiszerlánc-biztonság)" },
  { value: "Népegészségügy", label: "Népegészségügyi hatóság (ÁNTSZ)" },
  { value: "Munkavédelmi felügyelőség", label: "Munkavédelmi felügyelőség" },
  { value: "Tűzoltóság", label: "Tűzoltóság" },
  { value: "Fogyasztóvédelem", label: "Fogyasztóvédelem" },
  { value: "Rendőrség", label: "Rendőrség" },
  { value: "Önkormányzat", label: "Önkormányzat" },
  { value: "Kormányhivatal", label: "Kormányhivatal" },
  { value: "other", label: "Egyéb (saját)" },
];

export const AUTHORITY_VALUES = new Set(
  AUTHORITY_OPTIONS.filter((a) => a.value !== "other").map((a) => a.value)
);

export function authorityToFormState(authority) {
  if (!authority) {
    return { select: "", custom: "" };
  }
  if (AUTHORITY_VALUES.has(authority)) {
    return { select: authority, custom: "" };
  }
  return { select: "other", custom: authority };
}

export function authorityFromFormState(state) {
  if (state.select === "other") return state.custom.trim();
  return state.select.trim();
}
